import script from "./TreeItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeItem.vue?vue&type=script&lang=ts&setup=true"

import "./TreeItem.vue?vue&type=style&index=0&id=49aaddab&lang=css"

const __exports__ = script;

export default __exports__